// R6-2 — THE SYMBOL TABLES, MOVED VERBATIM OUT OF App.tsx.
//
// What the chart tables and the report cards actually print next to a placement. A missing or
// duplicated glyph draws the WRONG symbol on a real member's wheel with no error anywhere on the
// screen — the reading looks finished and says something else — which is why these live in a file a
// gate can load (`scripts/r6-catalogs.mjs`) instead of a file it can only grep.
//
// This module imports NOTHING, which is the entry requirement for that loader.

export const ACG_THEME_LABELS: Record<string, string> = {
  love: "For love", money: "For money", career: "For career and standing",
  home: "For home and rest", spirit: "For spirit",
};

export const SIGN_GLYPHS: Record<string, string> = {
  Aries: "♈", Taurus: "♉", Gemini: "♊", Cancer: "♋",
  Leo: "♌", Virgo: "♍", Libra: "♎", Scorpio: "♏",
  Sagittarius: "♐", Capricorn: "♑", Aquarius: "♒", Pisces: "♓",
};

export const PLANET_GLYPHS: Record<string, string> = {
  Sun: "☉", Moon: "☽", Mercury: "☿", Venus: "♀", Mars: "♂",
  Jupiter: "♃", Saturn: "♄", Uranus: "♅", Neptune: "♆", Pluto: "♇",
  "North Node": "☊", "South Node": "☋", Node: "☊", Chiron: "⚷", Lilith: "⚸",
};

export const ROMAN_HOUSES = ["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII"];

// 14-B6c — THE TWELVE MARKS ON THE ASTROLOGY ROOM'S ROTATING DISC, which were twelve hand-typed
// JSX lines carrying a CROSSING nothing held: each line types a sign into a class name
// (`zodiac-mark--capricorn`, which is what the stylesheet positions it by) and types a two-letter
// mark beside it, and **the mark is not derivable from the sign** — Cancer is "Ca" and Capricorn is
// "Cp". A line that lost its sign left a gap in the disc and a line that wore the wrong mark drew
// Cancer where Capricorn belongs, both silently, on the room's own art.
//
// So it is a ROSTER here and the disc is DERIVED from it (R31: the crossing stops existing rather
// than being watched), and `scripts/r6-catalogs.mjs` holds it to `ZODIAC_SIGNS` as a biconditional
// BY IMPORT — this module still imports nothing, which is the loader's entry requirement.
export const ZODIAC_MARKS: Record<string, string> = {
  aries: "Ar", taurus: "Ta", gemini: "Ge", cancer: "Ca",
  leo: "Le", virgo: "Vi", libra: "Li", scorpio: "Sc",
  sagittarius: "Sa", capricorn: "Cp", aquarius: "Aq", pisces: "Pi",
};

// The same room's three drifting threads and three drifting planets, named rather than repeated.
export const ASTRO_STAGE_THREADS = ["one", "two", "three"];
export const ASTRO_STAGE_PLANETS = ["sun", "moon", "venus"];
